module.exports = __webpack_public_path__ + "img/1-2.e6c58279.png";